import { RouteObject } from "react-router-dom";
import QuickMessageLanding from "./landing/landing";

export interface uxQuickMessageRoute extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: uxQuickMessageRoute[];
}

export const uxQuickMessageRoutes: uxQuickMessageRoute[] = [
  {
    path: "communication-hub/quick-message",
    element: <QuickMessageLanding />,
  },
];
